import React,{ memo, VFC, useState, useEffect } from 'react';
import {
  Table,Tbody,Tr,Th,Td,Text,
  Box,Flex,Stack
} from '@chakra-ui/react';
import { CopyIconButton } from '../atoms/button/CopyIconButton';
import { issueDetailObj } from '../../types/issue';

const headerDetail = {
  cloudType: 'クラウド種別／障害リージョン／サービス',
  cloudType_AZ: 'クラウド種別／障害リージョン／AZ／サービス',
  issueStatus: '状況',
  failTerm: '障害発生期間(JST)',
  issueArn: 'クラウド内障害識別子',
};

const issueConst = {
  split: '／',
  caseId: 'Case ID:',
}

type Props = {
  issueDetailObj: issueDetailObj;
};

export const IssueDetail: VFC<Props> = memo((props) => {
  const { issueDetailObj } = props;
  const [ cloudType, setCloudType ] = useState("");
  const [ regions, setRegions ]       = useState<Array<string>>([]);
  const [ startTime, setStartTime ]   = useState("");
  const [ endTime, setEndTime ]       = useState("");
  const [ failTerm, setFailTerm ]     = useState("");
  const [ issueStatus, setIssueStatus ] = useState("");
  // const [ issueArn, setIssueArn ] = useState("");
  const [ azFlag, setAzFlag] = useState(false);
  const [ headerArray, setHeaderArray ] = useState<Array<Array<string>>>([]);
  const openState = "継続中";

  useEffect(() => {
    if( issueDetailObj ){
      setCloudType(issueDetailObj.cloud_type ?? "");
      setRegions(issueDetailObj.region_service_list ?? []);
      setStartTime(issueDetailObj.start_time ?? "");
      setEndTime(issueDetailObj.end_time ?? "");
      setFailTerm(issueDetailObj.fail_term ?? "");
      setIssueStatus(issueDetailObj.status ?? "");
      setAzFlag(issueDetailObj.az_flag ?? "");
      // 障害識別子情報を設定
      setIssueInfo(issueDetailObj);
    }
  }, [issueDetailObj]);

  const setIssueInfo = (issue: issueDetailObj) => {
    const headerArrayTmp = []
    // カテゴリを取得する
    const tempIssueArn = issue.health_arn ?? "";
    const category = issue.event_category ?? "";
    // 関連情報を設定する。
    const link_arn = issue.link_health_arn ?? "";
    const link_case = issue.link_case_id ?? "";
    // 関連情報なしの場合
    if (!link_arn && !link_case) {
      const issueData = [category + tempIssueArn, category + tempIssueArn];
      headerArrayTmp.push(issueData);
    // 関連情報設定ありの場合
    }else if (link_arn && link_case) {
      const issueData = [category + link_arn, category + link_arn];
      headerArrayTmp.push(issueData);
      const issueData2 = [issueConst.split + issueConst.caseId + link_case, link_case];
      headerArrayTmp.push(issueData2);
    // 関連ARNのみ設定されている場合
    }else if (link_arn && !link_case) {
      const issueData = [category + link_arn, category + link_arn];
      headerArrayTmp.push(issueData);
    // 関連ケースIDのみ設定されている場合
    }else if (!link_arn && link_case) {
      const issueData = [category + issueConst.caseId + link_case, link_case];
      headerArrayTmp.push(issueData);
    }
    // 表示データを格納
    setHeaderArray(headerArrayTmp);
    // setIssueArn(tempIssueArn);
  };

  // 障害識別子表示内容を設定
  const createIssueMsg = (issues: string[], index: number) => {
    return (
      <Flex key={index}>
        <Text fontSize="sm" marginRight="4px">{issues[0].replace(/\//g,' / ')}</Text>
        <CopyIconButton id={issues[1]} value={issues[1]} />
      </Flex>
    )
  };

  return (
    <>
      {issueDetailObj && (
        <Box m="10px">
        <Table id="detail-outline" colorScheme="gray" variant="striped" size="sm" align="center">
          <Tbody>
            <Tr id="cloudType">
              <Th backgroundColor="#aaaaaa" color="white">
                {azFlag ? (
                  headerDetail.cloudType_AZ
                ) : (
                  headerDetail.cloudType
                )}
              </Th>
              <Td>
                {failTerm.includes(openState) ? (
                  regions.map((region:string,index) => (
                    <React.Fragment key={index}>
                      <Text fontSize="sm" color="red">{cloudType}／{region}</Text>
                      <br />
                    </React.Fragment>
                ))) : (
                  regions.map((region:string,index) => (
                    <React.Fragment key={index}>
                      <Text fontSize="sm">{cloudType}／{region}</Text>
                      <br />
                    </React.Fragment>
                )))}
              </Td>
            </Tr>
            <Tr id="issueStatus">
              <Th backgroundColor="#aaaaaa" color="white">
                {headerDetail.issueStatus}
              </Th>
              <Td whiteSpace="pre-line">
                {failTerm.includes(openState) ? (
                  <Text fontSize="sm" color="red">{issueStatus}</Text>
                ) : (
                  <Text fontSize="sm">{issueStatus}</Text>
                )}
              </Td>
            </Tr>
            <Tr id="fail-term">
              <Th backgroundColor="#aaaaaa" color="white">
                {headerDetail.failTerm}
              </Th>
              <Td>
                { !failTerm ? (
                  <Text></Text>
                ) : failTerm.includes(openState) && endTime ? (
                  <Text fontSize="sm" color="red">{`${startTime} ～ ${endTime}`+'　'+`（対応期限）［現在までの障害発生時間：${failTerm}］`}</Text>
                ) : failTerm.includes(openState) && !endTime ? (
                  <Text fontSize="sm" color="red">{`${startTime} ～ ${endTime}`+'　'+`［障害発生時間：${failTerm}］`}</Text>
                ) : (
                  <Text fontSize="sm">{`${startTime} ～ ${endTime}`+'　'+`［障害発生時間：${failTerm}］`}</Text>
                )}
              </Td>
            </Tr>
            <Tr id="issueArn">
              <Th backgroundColor="#aaaaaa" color="white">
                {headerDetail.issueArn}
              </Th>
              <Td>
                <Stack>
                  {headerArray.map((item:string[],index:number) => (
                    createIssueMsg(item,index)
                  ))}
                </Stack>
              </Td>
            </Tr>
          </Tbody>
        </Table>
        </Box>
      )}
    </>
  );
});
